import { Dropdown as AntdDropdown } from 'antd'

export const Dropdown = (props: any) => {
  return <AntdDropdown {...props}>{props.children}</AntdDropdown>
}
